import MobileBottomBar from "components/BottomBar/MobileBottomBar";
import ForgotPasswordDialog from "components/Dialog/ForgotPasswordDialog";
import SignInDialog from "components/Dialog/SignInDialog";
import SignUpDialong from "components/Dialog/SignUpDialong";
import VerifyEmailDialog from "components/Dialog/VerifyEmailDialog";
import MainHeader from "components/Header/MainHeader";
import LeftSidebar from "components/Sidebar/LeftSidebar";
import React from "react";

const AppLayout = ({
  children,
  isSearchVisable = true,
  isSearchScreen = false,
}) => {
  return (
    <main className="">
      <MainHeader
        isSearchVisable={isSearchVisable}
        isSearchScreen={isSearchScreen}
      />
      <div className="flex items-start ">
        <LeftSidebar />
        <div className="flex-1 w-full overflow-x-hidden">{children}</div>
      </div>
      <MobileBottomBar />
      <SignInDialog />
      <SignUpDialong />
      <ForgotPasswordDialog />
      <VerifyEmailDialog />
    </main>
  );
};

export default AppLayout;
